/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/frame_dome_hidden': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M1 23.5H0V32h8.5v-1H1zM14.269 31h3.461v1h-3.461zM31 31h-7.5v1H32v-8.5h-1zM31 14.27h1v3.46h-1zM23.5 0v1H31v7.5h1V0zM14.27 0h3.46v1h-3.46zM1 1h7.5V0H0v8.5h1zM0 14.27h1v3.46H0zM21 8h2v1h-2zM23 9h1v2h-1zM21 10h1v1h-1zM21 13h1v1h-1zM23 15h1v-3h-1v2h-1v1zM21 17v-2h-2v-1h-1v1h-1v1h-1v1h2v-1h1v1zM23 18h1v5h-1zM22 21v-3h-2v1h1v2h-2v-1h1v-1h-1v-1h-1v4h4zM21 23h2v1h-2zM18 22h-1v2h3v-1h-2zM9 23h2v1H9zM8 21h1v2H8zM9 8h2v1H9zM8 9h1v5H8zM9 17H8v3h1v-2h1v-1zM10 21h1v1h-1zM10 18h1v1h-1zM10 11v3h2v-1h-1v-2h2v1h-1v1h1v1h1v-4h-4zM14 10h1V8h-3v1h2zM16 13h2v1h-2zM14 18h2v1h-2zM15 15h-1v1h-1v-1h-2v2h2v1h1v-1h1v-1h1v-1zM15 11h1v2h-1zM16 19h1v2h-1zM17 9h2v2h-1v-1h-1v2h2v1h2v-2h-1V8h-3zM16 9h1v1h-1zM15 23h-2v-2h1v1h1v-2h-2v-1h-2v2h1v3h3zM15 22h1v1h-1z"/>'
  }
})
